import React, { Fragment } from 'react';
import './location.scss';
import { connect } from 'react-redux';
import history from 'hb-redux-store/history';
import Input from 'components/mweb/Input/Input';
import { setItem, getItem } from 'hb-redux-store/util/localStorageService';
import {
  getPlacePredictions,
  initializeMap,
  setGeoLocationPosition,
  checkLocationPermission,
  setPlace,
  getRecentSearches,
  GEOLOCATION_TIMEOUT,
} from 'hb-redux-store/util/locationService';
import {
  getAddressForLocation,
  postUserLocation,
  getHomePageSection,
} from 'hb-redux-store/feature/home/home.action';
import { getCheckoutRoute } from '../checkout/checkout.routes';
import Icon from 'components/mweb/Icon/Icon';
import Drawer from 'components/common/Drawer';
import LocationMap from 'components/web-feature/location/LocationMap';
import {
  showLocationSearchModal,
  showAddressListModal,
  showLocationMap,
} from 'hb-redux-store/feature/modal/modal.action';
import AddAddress from 'components/web-feature/checkout/AddAddress';
import CookieService from 'hb-redux-store/util/cookieService';
import Messages from '../../mweb/Messages/Messages';
import AnalyticsService from '../../../AnalyticsService';

const geolocation = navigator.geolocation;

class Location extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchKey: '',
      searchList: [],
      // searchList: getLocationPrediction().data.map(p => ({
      //   description: p.description,
      //   id: p.place_id,
      //   mainText: p.structured_formatting.main_text,
      //   secondaryText: p.structured_formatting.secondary_text,
      // })),
      recentSearches: getRecentSearches(),
      showGeoLocation: !!geolocation,
      geoLocationCTA: 'Select current location',
      geoLocationError: '',
      geoLocationButtonEnabled: true,
      confirmLocation: false,
      showAddressModal: false,
    };
    this.isCheckout = props.path === getCheckoutRoute('location');
  }

  componentDidMount() {
    initializeMap();
    this.initializeGeoLocation();
    // !this.isCheckout && this.props.getAddressForLocation();
  }
  componentWillUnmount() {
    initializeMap();
    this.initializeGeoLocation();
  }

  initializeGeoLocation = () => {
    let geoLocationCTA = null;
    if (geolocation) {
      // console.log('checking permission');
      checkLocationPermission().then(result => {
        console.log('permissions: ', result);
        if (result.state === 'granted' || result.state === 'prompt') {
          geoLocationCTA = 'Select current Location';
        } else if (result.state === 'denied') {
          geoLocationCTA = 'Location permission was denied previously.';
        }
        // result.onchange = this.initializeGeoLocation;
        this.setState({ geoLocationCTA });
      });
    } else {
      geoLocationCTA = 'Your device does not support location.';
    }
  };

  searchPromise = null;
  searchLocation = ({ searchKey }) => {
    if (this.searchPromise !== null) {
      clearTimeout(this.searchPromise);
      this.searchPromise = null;
    }
    this.setState({ searchKey }, () => {
      this.searchPromise = setTimeout(() => {
        const key = this.state.searchKey;
        if (key && key.length > 3) {
          console.log('Calling search with: ', key);
          const predictionRequest = {
            input: key,
            region: 'in',
            country: 'in',
            componentRestrictions: { country: 'in' },
          };
          getPlacePredictions(predictionRequest)
            .then(resp => {
              this.setState({
                searchList: resp.map(p => ({
                  description: p.description,
                  id: p.place_id,
                  mainText: p.structured_formatting.main_text,
                  secondaryText: p.structured_formatting.secondary_text,
                  place: p,
                })),
              });
            })
            .catch(e => {
              console.log('Error getting places: ', e);
            });
        }
      }, 400);
    });
  };

  askLocationPermission = () => {
    if (this.state.geoLocationButtonEnabled) {
      this.setState({ geoLocationButtonEnabled: false }, () => {
        geolocation.getCurrentPosition(
          position => {
            console.log('position: ', position);
            const gtmData = {
              eventName: 'locationSetCurrentLocation',
              eventData: {
                category: `location > set_current_location`,
                action: 'search_page',
                label: `lat: ${position.coords?.latitude}, long: ${position.coords?.longitude}`,
              },
            };
            AnalyticsService.trackGtmEvent(gtmData);
            setGeoLocationPosition(position);
            this.props.showLocationMap(true);
            // history.push('/location/map');
          },
          err => {
            console.log('error: ', err);
            this.setState({ geoLocationButtonEnabled: true });
          },
          { timeout: GEOLOCATION_TIMEOUT }
        );
      });
      this.setState({ geoLocationButtonEnabled: true });
    }
  };

  showAddressModal = value => {
    this.setState({ showAddressModal: value });
  };

  isLoggedInUser = () =>
    this.props.loggedInState && CookieService.isLoggedInUser();

  saveAndShowMap = place => {
    const { showLocationMap, typeOfCTA } = this.props;
    this.showAddressModal(false);
    // Clevertap Analytics
    const key = 'Selected Search Location';
    const payload = {
      name: place?.mainText,
      searchLocation: place?.description,
    };
    AnalyticsService.clevertap.sendCleverTapEvent(key, payload);

    if (!this.state.recentSearches) {
      setItem('recentSearches', [place]);
    } else {
      const recentSearches = this.state.recentSearches
        .filter(p => p.id !== place.id)
        .slice(0, 4);
      setItem('recentSearches', [place, ...recentSearches]);
    }
    setPlace(place);
    if (this.isCheckout) {
      history.goBack();
    } else {
      if (typeOfCTA === 'changeAddress' && this.isLoggedInUser()) {
        this.showAddressModal(true);
      } else {
        const gtmData = {
          eventName: 'locationSetSearchedLocation',
          eventData: {
            category: `location > set_searched_location`,
            label: `${place.id}: ${place.description}`,
          },
        };
        AnalyticsService.trackGtmEvent(gtmData);
        showLocationMap(true);
        // history.push('/location/map');
      }
    }
  };

  enableGeoLocatnBtn = () => {
    this.setState({
      geoLocationButtonEnabled: true,
    });
  };

  setLocation = place => {
    this.props.showLocationSearchModal({
      locationSearchModal: false,
      typeOfCTA: 'location',
    });
    this.props.showAddressListModal(false);
    const gtmData = {
      eventName: 'locationSetSavedAddress',
      eventData: {
        category: `location > set_saved_address`,
        value: place.addressId,
        label: place.addressLine1,
      },
    };
    AnalyticsService.trackGtmEvent(gtmData);
    this.props.postUserLocation(place);
  };
  render() {
    const {
      searchList,
      recentSearches,
      geoLocationCTA,
      geoLocationError,
      showGeoLocation,
    } = this.state;
    const { savedAddress, loading, confirmLocationMap } = this.props;
    const path =
      history.location &&
      history.location.pathname &&
      history.location.pathname.split('/')[1];
    const prefix = path === 'my' ? path : 'co';
    const helpText = (
      <span>
        Please search for your <span className="bold">Society</span> name to
        select accurate location
      </span>
    );
    return (
      <Fragment>
        <Drawer
          title="SEARCH LOCATION"
          placement="right"
          closable={true}
          onClose={() => {
            this.props.showLocationSearchModal({
              locationSearchModal: false,
              typeOfCTA: 'location',
            });
          }}
          visible={this.props.locationSearchModal}
          destroyOnClose={true}
          maskClosable={true}
          afterVisibleChange={() => {
            initializeMap();
            this.initializeGeoLocation();
          }}
          width={500}
        >
          <div className="desktop-location">
            <div className="desktop-location--search-container">
              <Input
                className="search--search-container--search-box"
                type={'text'}
                onChange={this.searchLocation}
                placeholder="Search your location, eg Worli.."
                autoFocus
                value={this.state.searchKey}
                name="searchKey"
                clearText
              />
            </div>
            <div className="desktop-location--help-text">
              <Messages type="toast" message={helpText} />
            </div>
            {showGeoLocation && (
              <div
                className="desktop-location--current-location justify-content--space-between"
                onClick={this.askLocationPermission}
              >
                <div className="flex-align-items-center">
                  <Icon size={24} class="icon-location-crosshair" />
                  <div className="desktop-location--current-location--text cursor-hover">
                    {geoLocationCTA}
                  </div>
                </div>
                <Icon size={14} class="icon-common-red-arrow-right" />
              </div>
            )}
            {searchList.length > 0 && (
              <div className="desktop-location--places">
                <div className="desktop-location--places--title">
                  Search Results
                </div>
                {searchList.map(place => (
                  <div
                    onClick={() => this.saveAndShowMap(place)}
                    key={place.id}
                    className="cursor-hover"
                  >
                    <div className="desktop-location--places--main-text">
                      {place.mainText}
                    </div>
                    <div className="desktop-location--places--secondary-text">
                      {place.secondaryText}
                    </div>
                  </div>
                ))}
              </div>
            )}
            {savedAddress && savedAddress.length > 0 && (
              <div className="desktop-location--places">
                <div className="desktop-location--places--title">
                  Saved Address
                </div>
                {savedAddress.map(place => (
                  <div
                    onClick={() => this.setLocation(place)}
                    key={place.addressId}
                    className="cursor-hover"
                  >
                    <div className="desktop-location--places--main-text">
                      {place.addressType || place.area}
                    </div>
                    <div className="desktop-location--places--secondary-text">
                      {place.addressType ? place.area : place.addressLine2}
                    </div>
                  </div>
                ))}
              </div>
            )}
            {recentSearches && recentSearches.length > 0 && (
              <div className="desktop-location--places">
                <div className="desktop-location--places--title">
                  Recent Searches
                </div>
                {recentSearches.map(place => (
                  <div
                    onClick={() => this.saveAndShowMap(place)}
                    key={place.id}
                    className="cursor-hover"
                  >
                    <div className="desktop-location--places--main-text">
                      {place.mainText}
                    </div>
                    <div className="desktop-location--places--secondary-text">
                      {place.secondaryText}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </Drawer>
        {confirmLocationMap && (
          <LocationMap enableGeoLocatnBtn={this.enableGeoLocatnBtn} />
        )}
        {this.state.showAddressModal && (
          <AddAddress
            prefix={prefix}
            actionType="new"
            addressId={null}
            showModal={this.showAddressModal}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = ({ homeReducer, modalReducer, initialReducer }) => ({
  savedAddress: homeReducer.savedAddress,
  locationSearchModal: modalReducer.locationSearchModal,
  typeOfCTA: modalReducer.typeOfCTA,
  confirmLocationMap: modalReducer.confirmLocationMap,
  loggedInState: initialReducer.launchInfo.loggedIn,
});

const mapDispatchToProps = {
  getAddressForLocation,
  postUserLocation,
  getHomePageSection,
  showLocationSearchModal,
  showLocationMap,
  showAddressListModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(Location);
